export const OFF_TOPIC_PREFIX = "I'm sorry, but I can't";
export const OFF_TOPIC_MESSAGE =
  "I'm sorry, but I can't answer questions outside web development.";

export const MESSAGE_SEARCHING = "Searching for MDN content…";
export const MESSAGE_SEARCHED = "Consulted MDN content:";
export const MESSAGE_ANSWERING = "Generating your answer…";
export const MESSAGE_ANSWERED = "Answer:";
export const MESSAGE_STOPPED = "Answer (stopped):";
export const MESSAGE_FAILED = "Error generating your answer!";

export const EVENT_TIMEOUT = 15000;
